module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0OCAxMjhBNDggNDggMCAwIDEgODk2IDE3NnY2NzJhNDggNDggMCAwIDEtNDggNDhoLTY3MkE0OCA0OCAwIDAgMSAxMjggODQ4di02NzJBNDggNDggMCAwIDEgMTc2IDEyOGg2NzJ6TTgzMiAxOTJIMTkydjY0MGg2NDBWMTkyeiBtLTEyOCAyODhhMzIgMzIgMCAwIDEgMCA2NEgzMjBhMzIgMzIgMCAwIDEgMC02NGgzODR6IiBmaWxsPSIjMCIgcC1pZD0iNzE5Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Shrink-outlined.svg
// module id = wvmW
// module chunks = 74